// Angular
import {Component, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

// Utils
import {provinces} from '../../../Assets/angular/assets/data/provinces';
import {environment} from '../../../environments/environment';
import {ClientService} from '../../services/client.service';
import {ModifyDataService} from '../../services/modify-data.service';
import {PrivateAreaService} from '../../services/private-area.service';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})

export class FormComponent implements OnInit {

    @Input() inputForm: Array<object>;
    @Input() address: string;
    @Input() cp: string;
    @Input() population: string;
    @Input() province: string;
    @Input() phone: string;

    // Form variables
    selectedFormGroup: FormGroup;
    selectedFormName: string;
    modifyDataForm: FormGroup;
    newPassForm: FormGroup;
    changeFirstPassForm: FormGroup;
    modifyPhoneForm: FormGroup;
    loginForm: FormGroup;
    dniForm: FormGroup;
    securityCodeForm: FormGroup;
    mailPassForm: FormGroup;

    // Login variables
    token: string;
    email = '';
    password = '';

    // Modal variables
    showDialog: boolean;
    showModalButton = false;
    buttonAction: any;
    buttonParam = '';
    buttonMessage = '';

    // Utils
    showLoader = false;
    provinces: Array<string>;
    apiKey: string;
    textMessage = '';
    modalId = 'modal-login-form';
    closeAction = '';

    constructor(public clientService: ClientService, public modifyDataService: ModifyDataService,
                private router: Router) {
        this.selectedFormName = '';
        this.token = localStorage.getItem('token');
        this.loginForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email,
                Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]),
            pass: new FormControl('', Validators.required)
        });
        this.modifyDataForm = new FormGroup({
            address: new FormControl('', Validators.required),
            population: new FormControl('', Validators.required),
            province: new FormControl('', Validators.required),
            cp: new FormControl('', [Validators.maxLength(5), Validators.minLength(5), Validators.required]),
        });
        this.newPassForm = new FormGroup({
                password: new FormControl('', [Validators.required, this.patternValidator]),
                confirmPassword: new FormControl('', Validators.required)
            },
            this.mustMatch('password', 'confirmPassword')
        );
        this.changeFirstPassForm = new FormGroup(
            {
                password: new FormControl('', [Validators.required, this.patternValidator]),
                confirmPassword: new FormControl('', Validators.required)
            },
            this.mustMatch('password', 'confirmPassword')
        );
        this.modifyPhoneForm = new FormGroup({
            phone: new FormControl('', [Validators.maxLength(9), this.spanishPhoneValidator])
        });
        this.dniForm = new FormGroup({
                dni: new FormControl('', [Validators.required, Validators.maxLength(9), this.dniValidator]),
                recaptcha: new FormControl(null, Validators.required)
            }
        );
        this.securityCodeForm = new FormGroup({
            code: new FormControl('', Validators.required)
        });
        this.mailPassForm = new FormGroup(
            {
                email: new FormControl('', [Validators.required, Validators.email,
                    Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]),
                password: new FormControl('', [Validators.required, this.patternValidator]),
                confirmPassword: new FormControl('', Validators.required)
            },
            this.mustMatch('password', 'confirmPassword')
        );
        this.showDialog = false;
        this.provinces = provinces;
        this.apiKey = environment.google_api_key;
    }

    ngOnInit(): void {
        this.selectedFormName = this.inputForm[0]['cols'][0]['formGroup'];
        switch (this.selectedFormName) {
            case 'loginForm':
                this.selectedFormGroup = this.loginForm;
                break;
            case 'modifyDataForm':
                this.selectedFormGroup = this.modifyDataForm;
                break;
            case 'modifyPhoneForm':
                this.selectedFormGroup = this.modifyPhoneForm;
                break;
            case 'newPassForm':
                this.selectedFormGroup = this.newPassForm;
                break;
            case 'changeFirstPassForm':
                this.selectedFormGroup = this.changeFirstPassForm;
                break;
            case 'dniForm':
                this.selectedFormGroup = this.dniForm;
                break;
            case 'securityCodeForm':
                this.selectedFormGroup = this.securityCodeForm;
                break;
            case 'mailPassForm':
                this.selectedFormGroup = this.mailPassForm;
                break;
        }
        this.modifyDataForm.controls.address.setValue(this.address);
        this.modifyDataForm.controls.province.setValue(this.province, {onlySelf: true});
        this.modifyDataForm.controls.population.setValue(this.population);
        this.modifyDataForm.controls.cp.setValue(this.cp);
        this.modifyPhoneForm.controls.phone.setValue(this.phone);
    }

    get form() {
        switch (this.selectedFormName) {
            case 'loginForm':
                return this.loginForm.controls;
            case 'modifyDataForm':
                return this.modifyDataForm.controls;
            case 'modifyPhoneForm':
                return this.modifyPhoneForm.controls;
            case 'newPassForm':
                return this.selectedFormGroup.controls;
            case 'changeFirstPassForm':
                return this.changeFirstPassForm.controls;
            case 'dniForm':
                return this.dniForm.controls;
            case 'securityCodeForm':
                return this.securityCodeForm.controls;
            case 'mailPassForm':
                return this.mailPassForm.controls;
        }
    }

    onSubmit() {
        switch (this.selectedFormName) {
            case 'loginForm':
                const email = this.email = this.clientService.email = this.loginForm.controls.email.value.toLowerCase();
                const pass = this.password = this.clientService.password = this.loginForm.controls.pass.value;
                this.loginForm.markAllAsTouched();
                if (this.loginForm.status === 'VALID') {
                    this.showLoader = true;
                    this.login(email, pass);
                }
                break;
            case 'modifyDataForm':
                const address = this.modifyDataForm.controls.address.value;
                const population = this.modifyDataForm.controls.population.value;
                const province = this.modifyDataForm.controls.province.value;
                const cp = this.modifyDataForm.controls.cp.value;
                if (this.modifyDataForm.status === 'VALID' && this.modifyDataForm.pristine === false) {
                    this.textMessage = '¿Seguro que quieres modificar tus datos?';
                    this.modalId = 'modal-data-modification';
                    this.buttonMessage = 'Aceptar';
                    this.buttonAction = 'modifyData';
                    this.buttonParam = 'personal';
                    this.modifyDataService.adress = address;
                    this.modifyDataService.population = population;
                    this.modifyDataService.province = province;
                    this.modifyDataService.cp = cp;
                    console.log(this.modifyDataForm);
                    setTimeout(() => {
                        document.getElementById(this.modalId).classList.remove('d-none');
                    }, 500);
                    this.showModalButton = true;
                }
                break;
            case 'modifyPhoneForm':
                this.modifyPhoneForm.markAllAsTouched();
                const phone = this.modifyPhoneForm.controls.phone.value;
                if (this.modifyPhoneForm.status === 'VALID' && this.modifyPhoneForm.pristine === false) {
                    this.textMessage = '¿Seguro que quieres modificar tus datos?';
                    this.modalId = 'modal-data-modification-phone';
                    this.buttonMessage = 'Aceptar';
                    this.buttonAction = 'modifyDataPhone';
                    this.buttonParam = 'phone';
                    sessionStorage.setItem('modify_phone_data', phone);
                    setTimeout(() => {
                        document.getElementById(this.modalId).classList.remove('d-none');
                    }, 500);
                    this.showModalButton = true;
                }
                break;
            case 'dniForm':
                const dni = this.dniForm.controls.dni.value;
                this.dniForm.markAllAsTouched();
                switch (this.router.url) {
                    case '/contrasena-olvidada':
                        if (this.dniForm.status === 'VALID') {
                            this.showLoader = true;
                            this.modifyDataService.requestPassReset(dni).subscribe(res => {
                                sessionStorage.setItem('forgotpassword', res.sequence);
                                this.router.navigateByUrl('codigo-seguridad');
                            }, error => {
                                this.showLoader = false;
                                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                                this.modalId = 'modal-forgot-password';
                                setTimeout(() => {
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                }, 500);
                                if (error.error.status === 400 && error.error.message === 'La cuenta está bloqueada. No es posible actualizar la contraseña. Por favor acude a tu tienda más cercana con tu documento de identificación para reactivar tu acceso al Área de Clientes') {
                                    this.textMessage = 'La cuenta está bloqueada. No es posible actualizar la contraseña. Por favor acude a tu tienda más cercana con tu documento de identificación para reactivar tu acceso al Área de Clientes';
                                    this.closeAction = 'navigateToHome';
                                }
                            });
                        }
                        break;
                    case '/activar-acceso':
                        if (this.dniForm.status === 'VALID') {
                            this.showLoader = true;
                            this.clientService.activateAccess(dni).subscribe(res => {
                                sessionStorage.setItem('sequence_activate_access', res.sequence);
                                sessionStorage.setItem('phone_activate_access', res.phone);
                                this.router.navigateByUrl('mensaje-validacion-acceso');
                            }, err => {
                                this.showLoader = false;
                                if (err.error.status === 400 && err.error.message === 'El documento ya se encuentra registrado como ciente online') {
                                    this.textMessage = 'El documento ya se encuentra registrado como cliente online';
                                    this.modalId = 'modal-error-existent-dni';
                                    setTimeout(() => {
                                        document.getElementById(this.modalId).classList.remove('d-none');
                                    }, 500);
                                }
                                if (err.error.status === 400 && err.error.message === 'El teléfono asociado a este documento ya registrado como ciente online') {
                                    this.textMessage = 'Hay un problema con su número de teléfono. Por favor, visite una de nuestras tiendas y nuestro personal le ayudará a solucionarlo';
                                    this.modalId = 'modal-error-telefono-en-uso';
                                    setTimeout(() => {
                                        document.getElementById(this.modalId).classList.remove('d-none');
                                    }, 500);
                                }
                                console.log('Error:', err);
                            });
                        }
                        break;
                }
                break;
            case 'newPassForm':
                this.newPassForm.markAllAsTouched();
                if (this.newPassForm.status === 'VALID') {
                    const password = this.newPassForm.controls.password.value;
                    this.showLoader = true;
                    this.modifyDataService.setNewPassword(password).subscribe(res => {
                        this.showLoader = false;
                        this.textMessage = 'Datos registrados correctamente';
                        this.buttonMessage = 'Aceptar';
                        this.buttonAction = 'navigateToHome';
                        this.showModalButton = true;
                        this.modalId = 'modal-datos-guardados';
                        this.closeAction = 'navigateToHome';
                        setTimeout(() => {
                            document.getElementById(this.modalId).classList.remove('d-none');
                        }, 500);
                    }, error => {
                        this.showLoader = false;
                        this.closeAction = 'navigateToHome';
                        this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                        setTimeout(() => {
                            document.getElementById(this.modalId).classList.remove('d-none');
                        }, 500);
                    });
                }
                break;
            case 'changeFirstPassForm':
                this.modalId = 'modal-contraseña-cambiada';
                if (this.changeFirstPassForm.status === 'VALID') {
                    const password = this.changeFirstPassForm.controls.password.value;
                    this.showLoader = true;
                    this.modifyDataService.changeFirstPassword(password).subscribe(res => {
                        this.showLoader = false;
                        this.textMessage = 'Su contraseña se ha cambiado correctamente';
                        this.closeAction = 'navigateToHome';
                        setTimeout(() => {
                            document.getElementById(this.modalId).classList.remove('d-none');
                        }, 500);
                    }, error => {
                        this.showLoader = false;
                        this.closeAction = 'navigateToHome';
                        this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                        setTimeout(() => {
                            document.getElementById(this.modalId).classList.remove('d-none');
                        }, 500);
                    });
                }
                break;
            case 'securityCodeForm':
                this.securityCodeForm.markAllAsTouched();
                const smsCode = this.securityCodeForm.controls.code.value;
                switch (this.router.url) {
                    case '/acceso-codigo-seguridad':
                        if (this.securityCodeForm.status === 'VALID') {
                            this.showLoader = true;
                            this.modalId = 'modal-access-security-code';
                            this.clientService.checkSmsCode(smsCode,
                                sessionStorage.getItem('sequence_activate_access_code')).subscribe(res => {
                                this.showLoader = false;
                                sessionStorage.setItem('sequence_activate_access_code', res.sequence);
                                this.buttonMessage = 'Aceptar';
                                this.textMessage = 'Ahora introduce los datos que utilizarás para acceder al área de clientes';
                                this.buttonAction = 'navigateToEmailPassSelection';
                                document.getElementById(this.modalId).classList.remove('d-none');
                                this.showModalButton = true;
                            }, error => {
                                this.showLoader = false;
                                if (error.status === 400 && error.error.message === 'Error: Invalid SMS Code') {
                                    this.textMessage = 'Has introducido un código incorrecto.';
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                } else if (error.status === 410) {
                                    this.textMessage = 'Ha expirado, obtenga un nuevo código.';
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                } else {
                                    this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                }
                            });
                        }
                        break;
                    case '/codigo-seguridad':
                        this.modalId = 'modal-error-security-code';
                        if (this.securityCodeForm.status === 'VALID') {
                            this.showLoader = true;
                            this.modifyDataService.checkResetCode(smsCode).subscribe(res => {
                                sessionStorage.setItem('forgotpassword', res.sequence);
                                this.router.navigateByUrl('nueva-contrasena');
                            }, error => {
                                this.showLoader = false;
                                if (error.error.status === 410) {
                                    this.textMessage = 'Ha expirado, obtenga un nuevo código.';
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                } else {
                                    this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                }
                            });
                        }
                        break;
                    case '/introducir-codigo-seguridad':
                        if (this.securityCodeForm.status === 'VALID') {
                            this.showLoader = true;
                            this.modifyDataService.confirmChangeUserPhone(smsCode).subscribe(res => {
                                this.showLoader = false;
                                this.textMessage = 'Los datos se han modificado correctamente';
                                this.closeAction = 'navigateToPersonalData';
                                setTimeout(() => {
                                    document.getElementById(this.modalId).classList.remove('d-none');
                                }, 500);
                            }, error => {
                                this.showLoader = false;
                                this.closeAction = 'navigateToPersonalData';
                                if (error.status === 400) {
                                    this.showLoader = false;
                                    if (error.error.message === 'Error: Invalid SMS Code') {
                                        this.textMessage = 'El código no es válido.';
                                    } else {
                                        this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                                    }
                                } else {
                                    this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                                }
                                document.getElementById(this.modalId).classList.remove('d-none');
                            });
                        }
                        break;
                }
                break;
            case 'mailPassForm':
                this.modalId = 'error-activate-access-data';
                if (this.mailPassForm.status === 'VALID') {
                    const selectedMail = this.mailPassForm.controls.email.value.toLowerCase();
                    const selectedPass = this.mailPassForm.controls.password.value;
                    this.showLoader = true;
                    this.clientService.clientAreaSignUp(selectedMail, selectedPass,
                        sessionStorage.getItem('sequence_activate_access_code')).subscribe(res => {
                        this.showLoader = false;
                        document.getElementById('confirm-email-pass-modal').classList.remove('d-none');
                    }, error => {
                        this.showLoader = false;
                        this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                        document.getElementById(this.modalId).classList.remove('d-none');
                    });
                }
                break;
        }
        if (this.showDialog) {
            this.showDialog = false;
        }
    }

    // LOGIN METHODS
    login(email, pass) {
        this.showLoader = true;
        this.clientService.login(email, pass).subscribe(
            res => {
                if (localStorage.getItem('token')) {
                    this.token = localStorage.getItem('token');
                    const currentToken = res.token;
                    const isTokenExpired = this.clientService.isTokenExpired(this.token);

                    if (isTokenExpired) {
                        localStorage.removeItem('token');
                        localStorage.setItem('token', currentToken);
                        this.router.navigateByUrl('/contratos');
                    } else {
                        this.showLoader = false;
                        this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                        document.getElementById('modal-login-form').classList.remove('d-none');
                    }
                } else {
                    if (res.token) {
                        this.token = this.clientService.token = res.token;
                        const isTokenExpired = this.clientService.isTokenExpired(this.token);

                        if (!isTokenExpired) {
                            localStorage.setItem('token', this.token);
                            this.router.navigateByUrl('/contratos');
                        }
                    } else {
                        this.showLoader = false;
                        this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                        document.getElementById('modal-login-form').classList.remove('d-none');
                    }
                }
            },
            error => {
                this.showLoader = false;
                if (error.status === 403) {
                    this.textMessage = 'El usuario o contraseña introducidos no es correcto. Por favor vuelva a' +
                        ' intentarlo.';
                    document.getElementById('modal-login-form').classList.remove('d-none');
                } else if (error.status === 423) {
                    this.textMessage = 'La cuenta está bloqueada. Por favor visita la tienda Superefectivo más' +
                        ' cercana, con tu documento de identificación personal en regla, para desbloquearla.';
                    document.getElementById('modal-login-form').classList.remove('d-none');
                } else if (error.status === 406) {
                    const data = {
                        sequence: error.error.sequence,
                        email
                    };
                    sessionStorage.setItem('sequenceFirstPass', JSON.stringify(data));
                    this.router.navigateByUrl('/cambiar-primera-contrasena');
                } else {
                    this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                    document.getElementById('modal-login-form').classList.remove('d-none');
                }
            }
        );
    }

    // PASSWORD METHODS
    mustMatch(controlName: string, matchingControlName: string): Validators {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }
            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({mustMatch: true});
            } else {
                matchingControl.setErrors(null);
            }
        };
    }

    patternValidator(control: AbstractControl) {
        const smallsPattern: RegExp = new RegExp('(?=.*[a-z])');
        const capsPattern: RegExp = new RegExp('(?=.*[A-Z])');
        const numberPattern: RegExp = new RegExp('(?=.*[0-9])');
        const errors = {
            invalidLength: false,
            invalidCaps: false,
            invalidSmalls: false,
            invalidNumbers: false
        };

        if (control.value.length < 8) {
            errors.invalidLength = true;
        }
        if (!control.value.match(capsPattern)) {
            errors.invalidCaps = true;
        }
        if (!control.value.match(smallsPattern)) {
            errors.invalidSmalls = true;
        }
        if (!control.value.match(numberPattern)) {
            errors.invalidNumbers = true;
        }

        if (errors.invalidLength === true || errors.invalidCaps === true || errors.invalidSmalls === true
            || errors.invalidNumbers === true) {
            return errors;
        } else {
            return null;
        }
    }

    // DNI/NIE Methods
    dniValidator(control: AbstractControl) {
        const nifRegex: RegExp = new RegExp(/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i);
        const nieRegex: RegExp = new RegExp(/^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i);
        const errors = {
            dniPatternError: false
        };
        if (!control.value.match(nieRegex) && !control.value.match(nifRegex)) {
            errors.dniPatternError = true;
            return errors;
        } else {
            return null;
        }
    }

    // Phone Methods
    spanishPhoneValidator(control: AbstractControl) {
        const landlinePattern: RegExp = new RegExp(/^(\+34|0034|34)?[89]\d{8}$/i);
        const mobilePattern: RegExp = new RegExp(/^(\+34|0034|34)?[67]\d{8}$/i);
        const errors = {
            phoneNumberError: false
        };

        if (!control.value?.match(landlinePattern) && !control.value?.match(mobilePattern)) {
            errors.phoneNumberError = true;
            return errors;
        } else {
            return null;
        }
    }

    forgotPassword() {
        this.router.navigateByUrl('contrasena-olvidada');
    }

    goToAccessRequest() {
        this.router.navigateByUrl('activar-acceso');
    }

    resendCode() {
        if (this.router.url === '/introducir-codigo-seguridad') {
            this.showLoader = true;
            this.modifyDataService.requestChangeUserPhone().subscribe(res => {
                this.showLoader = false;
                sessionStorage.setItem('sequence_modify_phone', res['sequence']);
            }, error => {
                this.showLoader = false;
                if (error.status === 400) {
                    if (error.error.message === 'El teléfono es el mismo registrado') {
                        this.textMessage = 'El teléfono es el mismo registrado, introduce un nuevo teléfono';
                    } else {
                        this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                    }
                } else {
                    this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                }
                setTimeout(() => {
                    document.getElementById(this.modalId).classList.remove('d-none');
                }, 500);
            });
        } else {
            this.showLoader = true;
            this.modalId = 'error-activate-access-sms';
            this.clientService.requestSmsCode().subscribe(res => {
                this.showLoader = false;
                sessionStorage.setItem('sequence_activate_access_code', res.sequence);
            }, error => {
                this.showLoader = false;
                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                document.getElementById(this.modalId).classList.remove('d-none');
            });
        }
    }

    navigateToHome() {
        this.router.navigateByUrl('');
    }

    modifyData() {
        this.showLoader = true;
        this.modifyDataService.changeDataClient().subscribe(res => {
            this.showLoader = false;
            this.textMessage = 'Los datos se han guardado correctamente';
            this.closeAction = 'navigateToPersonalData';
            this.showModalButton = false;
            setTimeout(() => {
                document.getElementById(this.modalId).classList.remove('d-none');
            }, 500);
        }, error => {
            this.showLoader = false;
            this.closeAction = 'navigateToPersonalData';
            this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
            this.showModalButton = false;
            setTimeout(() => {
                document.getElementById(this.modalId).classList.remove('d-none');
            }, 500);
        });
    }

    modifyDataPhone() {
        this.showLoader = true;
        this.modifyDataService.requestChangeUserPhone().subscribe(res => {
            this.showLoader = false;
            sessionStorage.setItem('sequence_modify_phone', res['sequence']);
            this.router.navigateByUrl('/introducir-codigo-seguridad');
        }, error => {
            this.showLoader = false;
            this.closeAction = 'navigateToPersonalData';
            this.showModalButton = false;
            if (error.status === 400) {
                if (error.error.message === 'El teléfono es el mismo registrado') {
                    this.textMessage = 'El teléfono es el mismo registrado, introduce un nuevo teléfono';
                } else if (error.error.message === 'El teléfono está ya registrado a un cliente') {
                    this.textMessage = `${error.error.message}, introduzca otro.`;
                } else {
                    this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
                }
            } else {
                this.textMessage = 'Algo ha fallado; inténtalo más tarde.';
            }
            setTimeout(() => {
                document.getElementById(this.modalId).classList.remove('d-none');
            }, 500);
        });
    }

    navigateToEmailPassSelection() {
        this.router.navigateByUrl('seleccionar-mail-pass');
    }

}
